module.exports = __webpack_public_path__ + "static/media/srebrzysko.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/srebrzysko.png
// module id = 874
// module chunks = 0